import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';

import classes from './Announcement.module.css';



function Announcement(){
    return(
        <div className={classes.container}>
            {/* <h3>{props.announcement}</h3>      */}
            <h4>All Decants 10% off. Offer till 10th January</h4> 
      </div>
    )
}


export default Announcement;   